import { Button } from '@cleartax/wg-library-button';
import * as Form from '@cleartax/wg-library-form';
import { useApi } from '@cleartax/wg-library-hooks';
import * as Modal from '@cleartax/wg-library-modal';
import { Heading, Text } from '@cleartax/wg-library-typography';
import { useRef, useState } from 'react';
import { trackAction } from '../../../../../../../../shared';
import StarRating from '../../../../../../../../shared/components/ui-blocks/star-rating/starRating.component';
import { postReview } from '../../../../../api/index.api';
import { usePlanCtx } from '../../../../planDetailsContext';
import { ReviewForm } from './reviewForm.component';

interface IReviewModal {
  isOpen: boolean;
  onClose: (isOpen: boolean) => void;
}

export const ReviewModal: React.FC<IReviewModal> = ({ isOpen, onClose }) => {
  const [formValid, setFormValid] = useState(false);
  const reviewApi = useApi<string>('', postReview);
  const planDetails = usePlanCtx();

  const [starRating, setStarRating] = useState(0);
  const formData = useRef<Record<string, Form.TFormValue>>({});
  const setFormData = (data: Record<string, Form.TFormValue>) => {
    formData.current = {
      ...formData.current,
      ...data,
    };
  };

  const setFormValidity = (
    isValid: boolean,
    value: Record<string, Form.TFormValue>
  ) => {
    setFormValid(isValid);
    if (isValid) {
      setFormData(value);
    }
  };

  const onSubmit = () => {
    reviewApi.request(planDetails.planId, {
      ...formData.current,
      reviewRating: starRating,
    });
    trackAction('click', '', { label: `form_submit_review_form` });
    onClose(false);
  };

  return (
    <Modal.ModalContainer
      isOpen={isOpen}
      className="top-1/4 p-4 rounded-lg sm:w-11/12"
      onClose={() => onClose(false)}
    >
      <div className="flex justify-between">
        <Heading textSize="3xl" className="text-brand-1000">
          Hi. Thank you for stopping by.
        </Heading>
        <Button name="close-review-modal" onClick={() => onClose(false)}>
          <Text
            textSize="xl"
            weight="bold"
            className="text-brand-1000 icon-clear"
          ></Text>
        </Button>
      </div>
      <div className="mt-5">
        <StarRating
          defaultState={0}
          emptyColor={'grey'}
          fillColor="#fbaa39"
          height={20}
          labelText={() => (
            <Text className="text-brand-1000">
              How do you rate our service?
            </Text>
          )}
          maxValue={5}
          onChangeHover={() => {}}
          onChangeValue={(value) => setStarRating(value)}
          width={20}
          readOnly={false}
        />
      </div>
      <Form.FormContainer initialValues={{}}>
        <ReviewForm setFormValidity={setFormValidity} />
      </Form.FormContainer>
      <Button
        variant="blue"
        className="w-full"
        disabled={!formValid || !starRating}
        onClick={() => onSubmit()}
      >
        Submit
      </Button>
    </Modal.ModalContainer>
  );
};
